// InactivityModal.js
// Modal dialog for inactivity warning and countdown
import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

function formatTime(ms) {
  const totalSeconds = Math.ceil(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

export default function InactivityModal({ open, countdown, onStayLoggedIn, onLogout }) {
  return (
    <Dialog open={open} disableEscapeKeyDown>
      <DialogTitle>Session Expiring Soon</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>
          You have been inactive for a while.<br />
          You will be logged out in <b>{formatTime(countdown)}</b> unless you stay logged in.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onLogout} color="error">Logout Now</Button>
        <Button onClick={onStayLoggedIn} color="primary" variant="contained">Stay Logged In</Button>
      </DialogActions>
    </Dialog>
  );
}
